import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IFriend } from '../../../../../types/friend';
import {
  IChat,
  IChatDating,
  SendMessagePayload,
} from '../../../../../types/chat';
import ChatContent from '../../../../../components/chat-content/chat-content.component';
import { IFriendDating } from '../../../../../hooks/use-dating/useDating';
import ChatContentDating from './ChatContentDating';
import ChatDatingEditor from './ChatDatingEditor';
// import ChatEditor from '../../../../../chat-editor/chat-editor.component';

interface ChatDetailDatingProps {
  user: IFriendDating;
  newMessage: IChatDating | null;
  handleSendMessage: (payload: SendMessagePayload) => void;
}

const ChatDetailDating = ({
  user,
  newMessage,
  handleSendMessage,
}: ChatDetailDatingProps) => {
  const navigator = useNavigate();
  return (
    <div className="flex">
      <div className="flex-1">
        <div className="flex flex-col justify-between">
          <div className="flex bg-[#F0F2F5] items-center justify-between gap-2 w- px-6 py-3.5  z-10 border-b dark:border-slate-700 uk-animation-slide-top-medium ">
            <div className="flex items-center sm:gap-4 gap-2">
              <div
                // onClick={() => navigator(`/user/${user.profileId}`)}
                className="relative max-md:hidden"
              >
                <img
                  alt="user"
                  src={
                    user.avatar ||
                    '/default-avatar.svg'
                  }
                  className="w-12 h-12 rounded-full shadow"
                />
              </div>
              <div>
                <div
                  // onClick={() => navigator(`/user/${user.profileId}`)}
                  className="text-[24px] leading-[29px] text-[#111827] font-bold"
                >
                  {user.nickname}
                </div>
                {/* <div className="text-xs text-green-500 font-semibold">
                  Online
                </div> */}
              </div>
            </div>
          </div>

          <ChatContentDating user={user} newMessage={newMessage} />

          <ChatDatingEditor user={user} handleSendMessage={handleSendMessage} />
        </div>
      </div>
    </div>
  );
};

export default ChatDetailDating;
